module.exports = "../../static/images/course-show4.ddcfa7.png";